(ns app.admin.data-import-repair
  (:require [schema-tools.coerce :as sc]
            [schema-tools.core :as st]
            [schema.core :as s]))

(def ^:private required-columns {:permit-number s/Str})

(def ^:private optional-columns {:address                s/Str
                                 :application-data-label s/Str
                                 :application-data-value s/Str
                                 :category               s/Str
                                 :work-type              s/Str
                                 :work-target            s/Str
                                 :state                  s/Str})

(def required-column-names (mapv name (keys required-columns)))

(def optional-column-names (mapv name (keys optional-columns)))

(s/defschema WorkspaceData (st/merge required-columns
                                     (st/optional-keys optional-columns)))

(def workspace-data-coercer (sc/coercer WorkspaceData sc/string-coercion-matcher))
